export const useStatusBarColor = (_color: string) => {
  // noop on ios and web
};
